/* eslint-disable react-refresh/only-export-components */
import { createContext, Dispatch, useContext } from 'react';
import { usePlanwerteFormReducer } from './usePlanwerteFormReducer';
import { PlanwerteEditForm, PlanwerteFormReducerAction } from './types';

type DialogContextProps = {
  planwerteForm: PlanwerteEditForm;
  dispatch: Dispatch<PlanwerteFormReducerAction>;
};

export const DialogContext = createContext<DialogContextProps | undefined>(
  undefined,
);

function DialogContextProvider({ children }: { children: React.ReactNode }) {
  const [planwerteForm, dispatch] = usePlanwerteFormReducer();

  const value: DialogContextProps = { planwerteForm, dispatch };

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
}

function useDialogContext() {
  const dialogContext = useContext(DialogContext);

  if (dialogContext === undefined) {
    throw new Error(
      'useDialogContext must be used within DialogContextProvider',
    );
  }
  return dialogContext;
}

export { useDialogContext, DialogContextProvider };
